import { decodeBase64Attachment } from "@qdabra/infopath-attachments";
import { FILE_NAME_KEY, FILE_SIZE_KEY } from "../constants/file.constants";
import { getNodeValue } from '../xmlUtility';
import { getNodeData, setNodeData } from "./nodeDataHelpers";

// FileProperties is { name: String, size: Number }

/**
 * Determines the name and size of the file stored in the specified node
 * Handles caching of these values and retrieves them from the cache if available.
 * @param {DOMNode} node The node in question
 * @returns {FileProperties} The properties for the file in the provided node
 */
export const getFileProperties = function (node) {
    if (!node) {
        return { name: '', size: 0 };
    }

    const fileName = getNodeData(node, FILE_NAME_KEY);

    if (fileName) {
        // values have already been cached
        return {
            name: fileName,
            size: getNodeData(node, FILE_SIZE_KEY),
        };
    }

    const fileBase64 = getNodeValue(node);
    const decoded = decodeBase64Attachment(fileBase64);

    const actualName = decoded.name;
    const fileSize = decoded.bytes.length;

    setNodeData(node, FILE_NAME_KEY, actualName);
    setNodeData(node, FILE_SIZE_KEY, fileSize);

    return { name: actualName, size: fileSize };
};

